import { defineMessages } from 'react-intl';

/** The return page of the SoundCloud sign-in (design b1-b3) and its result banner on Channels (b4-b6). */
export const soundCloudReturnMessages = defineMessages({
  workingTitle: { id: 'app.sml.soundcloud.return.working.title', defaultMessage: 'Connecting SoundCloud' },
  workingBody: {
    id: 'app.sml.soundcloud.return.working.body',
    defaultMessage: 'SoundCloud sent you back. MUSIC24 finishes the connection now. Keep this page open.',
  },
  stepAllowed: { id: 'app.sml.soundcloud.return.step.allowed', defaultMessage: 'You allowed MUSIC24 on SoundCloud' },
  stepSaving: { id: 'app.sml.soundcloud.return.step.saving', defaultMessage: 'Saving the connection' },
  stepProfile: { id: 'app.sml.soundcloud.return.step.profile', defaultMessage: 'Reading your profile' },
  connectedTitle: { id: 'app.sml.soundcloud.return.connected.title', defaultMessage: 'SoundCloud is connected' },
  connectedBody: {
    id: 'app.sml.soundcloud.return.connected.body',
    defaultMessage:
      'MUSIC24 reads your SoundCloud numbers every day. The first read takes a few minutes. You can publish your songs to SoundCloud from the song page.',
  },
  connectedPill: { id: 'app.sml.soundcloud.return.connected.pill', defaultMessage: 'Connected' },
  endedTitle: { id: 'app.sml.soundcloud.return.ended.title', defaultMessage: 'This sign-in ended' },
  endedBody: {
    id: 'app.sml.soundcloud.return.ended.body',
    defaultMessage: 'MUSIC24 waited more than 10 minutes, or this page opened twice in two tabs. Nothing changed.',
  },
  endedAlert: {
    id: 'app.sml.soundcloud.return.ended.alert',
    defaultMessage: 'Press Start again. The sign-in on SoundCloud takes about a minute.',
  },
  startAgain: { id: 'app.sml.soundcloud.return.startAgain', defaultMessage: 'Start again' },
  refusedTitle: { id: 'app.sml.soundcloud.return.refused.title', defaultMessage: 'SoundCloud did not connect' },
  refusedBody: {
    id: 'app.sml.soundcloud.return.refused.body',
    defaultMessage:
      'You pressed Cancel on SoundCloud, or SoundCloud stopped the sign-in. Nothing changed in your SoundCloud account.',
  },
  refusedAlert: {
    id: 'app.sml.soundcloud.return.refused.alert',
    defaultMessage: 'Try again and press “Connect and continue” on the SoundCloud page.',
  },
  failedTitle: { id: 'app.sml.soundcloud.return.failed.title', defaultMessage: 'We could not connect SoundCloud' },
  failedBody: {
    id: 'app.sml.soundcloud.return.failed.body',
    defaultMessage:
      'SoundCloud allowed MUSIC24, but we could not save the connection. Nothing changed in your SoundCloud account.',
  },
  failedAlert: {
    id: 'app.sml.soundcloud.return.failed.alert',
    defaultMessage: 'Try again in a minute. If it fails again, write to support@music24.com.',
  },
  inUseAlert: {
    id: 'app.sml.soundcloud.return.inUse.alert',
    defaultMessage: 'This SoundCloud login is connected to another artist in MUSIC24. Disconnect it there first.',
  },
  tryAgain: { id: 'app.sml.soundcloud.return.tryAgain', defaultMessage: 'Try again' },
});
